import { useMutation } from "@apollo/client";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";

import { UPDATE_MAILBOX } from "../mailbox.queries";
import { parseParams } from "../../../helpers/clean-object";

import { UpdateMailboxInput } from "../../../__generated__/globalTypes";
import {
  UpdateMailboxMutation,
  UpdateMailboxMutationVariables,
} from "../../../__generated__/UpdateMailboxMutation";

interface IProps {
  id: number;
  onCompleted: () => any;
}

export const useUpdateMailbox = ({ id, onCompleted }: IProps) => {
  const form = useForm<UpdateMailboxInput>({
    mode: "all",
  });
  const [mutate, { loading }] = useMutation<
    UpdateMailboxMutation,
    UpdateMailboxMutationVariables
  >(UPDATE_MAILBOX, {
    refetchQueries: "active",
  });

  const submit = async () => {
    if (loading) return;
    try {
      const input = form.getValues();
      const { data } = await mutate({
        variables: {
          id,
          input: parseParams(input),
        },
      });

      if (data?.updateMailbox?.ok) {
        toast.success("Boite mail mise à jour");
        onCompleted();
      } else {
        throw Error(data?.updateMailbox?.error ?? "Error");
      }
    } catch (error: any) {
      toast.error(error?.message ?? "Une erreur est survenue");
    }
  };

  return {
    form,
    mutate,
    loading,
    submit,
  };
};
